import React, { useState } from "react";
import Button from "../../../Components/Common/Button/Button";
import { useNavigate } from "react-router-dom";
import { Pathname } from "../../../Router/Pathname";
import copyIcon from '../../../Assets/icons/copy.svg';

const RefundCard = ({ refund }) => {
  const navigate = useNavigate();
  const [copiedId, setCopiedId] = useState(null);

  const handleCopy = (id) => {
    navigator.clipboard.writeText(id);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 2000);
  };

  if (!refund) {
    return null;
  }

  return (
    <div className="payment-container">
      <p className="payment-header">{refund.message}</p>

      {!!refund?.refundAmount && (
        <div className="payment-card">
          <p className="payment-title">Refund of</p>
          <h2 className="payment-amount">{refund.refundAmount}</h2>
          <p>Refund Ids:</p>
          <div className="refund-ids-container">
            {refund?.refundIds?.map((id, index) => (
              <div key={index} className="refund-id-row">
                <span className="refund-id">{id}</span>
                <img
                  src={copyIcon}
                  alt="Copy"
                  className="copy-icon"
                  onClick={() => handleCopy(id)}
                />
                {copiedId === id && (
                  <span>Copied</span>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

{refund?.showSupportBtn && <Button text={refund.buttonText} variant="chatButton" className="payment-button" onClick={()=>navigate(Pathname.HELP_AND_SUPPORT, {
      state: { fromChatBot: true },
    })}/>}
    </div>
  );
};

export default RefundCard;